<div
  translate
  appMobileResizeFix
  [ngClass]="{ 'is-menu-open': isSidebarOpen }"
  class="l-flex h-full"
>
  <sidebar></sidebar>

  <div
    class="l-cell-spread-x l-flex-column container-wrap"
    [class.mobile-nav-open]="isMobileNavOpen$ | async"
  >
    <navbar></navbar>

    <main id="content" class="l-cell-spread-y main-content" role="main">
      <router-outlet></router-outlet>
    </main>
  </div>

  <custom-popup></custom-popup>
</div>
